module.exports = __webpack_public_path__ + "static/media/2.4df52171.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/2.jpg
// module id = 193
// module chunks = 0